


















































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import {
  PopupBaseViewModel,
  createDialogOptions,
  createPopupModalViewModel,
  IDialogOptions,
  settings,
} from "survey-core";
import { BaseVue } from "../../base";

@Component
export class PopupContainer extends BaseVue {
  @Prop() model: PopupBaseViewModel;
  protected getModel() {
    return this.model;
  }
  clickInside(event: any) {
    event.stopPropagation();
  }
  onUpdated() {
    if (!this.model.isPositionSet && this.model.isVisible) {
      this.model.updateOnShowing();
    }
  }
}
// replace to showDialog then delete
export function showModal(
  componentName: string,
  data: any,
  onApply: () => boolean,
  onCancel?: () => void,
  cssClass?: string,
  title?: string,
  displayMode: "popup" | "overlay" = "popup"
): PopupBaseViewModel {
  const options = createDialogOptions(
    componentName,
    data,
    onApply,
    onCancel,
    undefined,
    undefined,
    cssClass,
    title,
    displayMode
  );
  return showDialog(options);
}
export function showDialog(dialogOptions: IDialogOptions, rootElement?: HTMLElement): PopupBaseViewModel {
  dialogOptions.onHide = () => {
    popup.$destroy();
    popupViewModel.container.remove();
    popupViewModel.dispose();
  };
  const popupViewModel: PopupBaseViewModel = createPopupModalViewModel(dialogOptions, rootElement);
  const popup = new PopupContainer({
    el: (<HTMLElement>popupViewModel.container).appendChild(document.createElement("div")),
    propsData: { model: popupViewModel },
  });
  popupViewModel.model.isVisible = true;
  return popupViewModel;
}
settings.showModal = showModal;
settings.showDialog = showDialog;
Vue.component("sv-popup-container", PopupContainer);
export default PopupContainer;
